'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dSign$002dHash$002dRequest from "./presto.-Agent-View$-Local-Pje-Office-Sign-Hash-Request.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$LocalPjeOfficeSignHashRequest$() {
}
export { $c_Lpresto_AgentView$LocalPjeOfficeSignHashRequest$ as $c_Lpresto_AgentView$LocalPjeOfficeSignHashRequest$ };
$p = $c_Lpresto_AgentView$LocalPjeOfficeSignHashRequest$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$LocalPjeOfficeSignHashRequest$;
/** @constructor */
function $h_Lpresto_AgentView$LocalPjeOfficeSignHashRequest$() {
}
export { $h_Lpresto_AgentView$LocalPjeOfficeSignHashRequest$ as $h_Lpresto_AgentView$LocalPjeOfficeSignHashRequest$ };
$h_Lpresto_AgentView$LocalPjeOfficeSignHashRequest$.prototype = $p;
$p.l = (function() {
  return "LocalPjeOfficeSignHashRequest";
});
$p.cFl = (function(x$0) {
  return new $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dSign$002dHash$002dRequest.$c_Lpresto_AgentView$LocalPjeOfficeSignHashRequest(x$0.j(0), x$0.j(1), x$0.j(2));
});
var $d_Lpresto_AgentView$LocalPjeOfficeSignHashRequest$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$LocalPjeOfficeSignHashRequest$, "presto.AgentView$LocalPjeOfficeSignHashRequest$", ({
  Eh: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_AgentView$LocalPjeOfficeSignHashRequest$ as $d_Lpresto_AgentView$LocalPjeOfficeSignHashRequest$ };
var $n_Lpresto_AgentView$LocalPjeOfficeSignHashRequest$;
function $m_Lpresto_AgentView$LocalPjeOfficeSignHashRequest$() {
  if ((!$n_Lpresto_AgentView$LocalPjeOfficeSignHashRequest$)) {
    $n_Lpresto_AgentView$LocalPjeOfficeSignHashRequest$ = new $c_Lpresto_AgentView$LocalPjeOfficeSignHashRequest$();
  }
  return $n_Lpresto_AgentView$LocalPjeOfficeSignHashRequest$;
}
export { $m_Lpresto_AgentView$LocalPjeOfficeSignHashRequest$ as $m_Lpresto_AgentView$LocalPjeOfficeSignHashRequest$ };
//# sourceMappingURL=presto.-Agent-View$-Local-Pje-Office-Sign-Hash-Request$.js.map
